import React from 'react'
import { useRouter } from 'next/navigation'
import { FaArrowRight } from 'react-icons/fa6'
interface ExploreAllButtonProps {
  name?: string
  link?: string
}
const ExploreAllButton = ({ link, name }: ExploreAllButtonProps) => {
  const router = useRouter()
  return (
    <>
      <div
        className={`flex justify-center items-center ${name === 'Shop All Looks' ? '' : 'w-full'} md:w-auto text-[16px] leading-[32px] font-barlowSemibold text-white cursor-pointer border border-[#A08260] rounded-[16px] px-[24px] py-[12px] mx-[15px] md:mx-[0px] `}
        onClick={() => link && router.push(link)}
      >
        <FaArrowRight className='mr-2' />
        {name ? name : 'Explore All'}
      </div>
    </>
  )
}

export default ExploreAllButton
